var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-tooltip"},[_c('i',{staticClass:"material-icons md-18"},[_vm._v("info")]),_c('div',{staticClass:"tooltip smooth-shadow"},[_c('p',[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }